import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const CalendarSvg = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.75 0.0716553V1.57166H10.25V0.0716553H11.75V1.57166H14.75C15.1642 1.57166 15.5 1.90745 15.5 2.32166V14.3217C15.5 14.7359 15.1642 15.0717 14.75 15.0717H1.25C0.83579 15.0717 0.5 14.7359 0.5 14.3217V2.32166C0.5 1.90745 0.83579 1.57166 1.25 1.57166H4.25V0.0716553H5.75ZM14 7.57166H2V13.5717H14V7.57166ZM5 9.07166V10.5717H3.5V9.07166H5ZM8.75 9.07166V10.5717H7.25V9.07166H8.75ZM12.5 9.07166V10.5717H11V9.07166H12.5ZM4.25 3.07166H2V6.07166H14V3.07166H11.75V4.57166H10.25V3.07166H5.75V4.57166H4.25V3.07166Z"
      fill="#3B495E"
    />
  </svg>
);

const Calendar = (props: IIconProps) => <Icon component={CalendarSvg} {...props} />;

export default Calendar;
